<div class="text-xs opacity-50">{{ label() }}</div>
<div class="flex flex-row items-center text-xl font-bold">
  <ng-content />
</div>
